// extracted by mini-css-extract-plugin
export default {"gradeselector":"Gradeselector__gradeselector--iDGMy"};